var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommentMultipleSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 2C6.53691 2 5.13339 3.32542 5.00897 5.00672C5.08874 5.00226 5.16911 5 5.25 5H14.75C17.0972 5 19 6.90279 19 9.25V15.75C19 15.8309 18.9977 15.9113 18.9933 15.991C20.6746 15.8666 22 14.4631 22 12.75V6.75C22 4.12665 19.8734 2 17.25 2H8.25Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9905 16C17.8629 17.6781 16.4608 19 14.75 19H10.6667L7 21.75C6.17595 22.368 5 21.7801 5 20.75V18.9905C3.32189 18.8629 2 17.4608 2 15.75V9.25C2 7.53919 3.32189 6.13713 5 6.00947C5.08251 6.0032 5.16588 6 5.25 6H14.75C16.5449 6 18 7.45507 18 9.25V15.75C18 15.8341 17.9968 15.9175 17.9905 16Z",
    fill: "#ffffff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentMultipleSvgrepoCom);
export default __webpack_public_path__ + "static/media/comment-multiple-svgrepo-com.f69425ee860b88e3f8e436b83aa01fee.svg";
export { ForwardRef as ReactComponent };